import React from 'react';
import { TColorRole, TTitleSize, colorMap } from '../../types/types';

interface ITitleProps {
    text: string;
    size: TTitleSize;
    color?: TColorRole;
}

export const Title: React.FC<ITitleProps> = ({ text, size = 'm', color = 'dark' }) => {
    const hexColor = colorMap[color] || colorMap['dark'];
    return (
        <h1 className={`title title-${size}`} style={{ color: `${hexColor}` }}>
            {text}
        </h1>
    );
};
